import { Axios } from "utils/axiosConfig";
export const ApiService = {
  /* AUTH APIS */
  loginUser: async (body) => {
    const { data } = await Axios.post(`account/login/`, {
      requestType: "inbound",
      data: body,
    });
    localStorage.setItem("token", data?.data?.accessToken);
    localStorage.setItem("user_data", JSON.stringify(data?.data?.userData));
    return data;
  },

  changePassword: async (body) => {
    const { data } = await Axios.post(`account/change-password/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },

  forgotPassword: async (body) => {
    const { data } = await Axios.post(`account/forgot-password/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },

  forgotPasswordMail: async (body) => {
    const { data } = await Axios.get(`account/forgot-password/?email=${body}`);
    return data;
  },

  verifyOtp: async (body) => {
    const { data } = await Axios.get(
      `account/confirm-otp?otp=${body}&userId=${localStorage.getItem(
        "user_id"
      )}`
    );
    return data;
  },

  /* AUTH APIS */

  /* DASHBOARD ANALYSIS */
  getDashboardAnalysis: async (body) => {
    const { data } = await Axios.get(`api/dashboard/${body || ""}`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },

  /* DASHBOARD ANALYSIS */

  /* INSTITUTIONS */
  getInstitution: async (body) => {
    const { data } = await Axios.get(`account/institution/${body || ""}`, {});
    return data;
  },
  getInstitutionDashboard: async (body) => {
    const { data } = await Axios.get(
      `account/institution-dashboard${(body && body) || ""}`,
      {}
    );
    return data;
  },
  getBalanceEnquiry: async (body) => {
    const { data } = await Axios.get(
      `/api/exchange/balance-enquiry/?institutionCode=${body}`,
      {}
    );
    return data;
  },
  getCreditHistory: async ({ institutionCode, dateFrom, dateTo, page, download }) => {
    const config = {
      params: { institutionCode, dateFrom, dateTo, page, download },
    };
    if (download) {
      config.responseType = "blob";
    }
    const { data } = await Axios.get(`/api/exchange/credit-history/`, config);
    return data;
  },
  getBalanceConfig: async (body) => {
    const { data } = await Axios.get(`/api/balance-configuration/`, {});
    return data;
  },
  editInstitution: async (id, body) => {
    const { data } = await Axios.put(`account/institution/${id}/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },
  createInstitution: async (body) => {
    const { data } = await Axios.post(`account/institution/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },
  createBalanceConfiguration: async (body) => {
    const { data } = await Axios.post(`/api/balance-configuration/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },
  updateBalanceConfiguration: async (id, body) => {
    const { data } = await Axios.post(`/api/balance-configuration/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },
  deleteBalanceConfiguration: async (id) => {
    const { data } = await Axios.delete(`/api/balance-configuration/${id}/`);
    return data;
  },
  getConfigTrigger: async (body) => {
    const { data } = await Axios.get(`account/route-trigger/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },
  emailTrigger: async (body) => {
    const { data } = await Axios.post(`account/email-trigger/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },

  configTrigger: async (body) => {
    const { data } = await Axios.post(`account/route-trigger/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },

  editConfigTrigger: async (body, id) => {
    const { data } = await Axios.put(`account/route-trigger/${id}/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },
  uploadImage: async (body) => {
    const { data } = await Axios.post(`account/institution/image/`, body);
    return data;
  },

  /* INSTITUTIONS */

  // Transaction
  getTransaction: async (body) => {
    const { data } = await Axios.get(`api/transaction/${body || ""}`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },

  // Transaction
  getTransactionSub: async (body) => {
    const { data } = await Axios.get(`api/transaction-db/${body || ""}`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },

  //ADMIN
  createAdmin: async (body) => {
    const { data } = await Axios.post(`account/create-user/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },
  //ADMIN
  editAdmin: async (id, body) => {
    const { data } = await Axios.put(`account/admin/${id}/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },
  getAdmins: async (body) => {
    const { data } = await Axios.get(`account/admin/${body || ""}`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },
  getAdminsAudit: async (body) => {
    const { data } = await Axios.get(`account/admin${body || ""}&audit=true`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },
  getOthersAuditTrail: async (body) => {
    const { data } = await Axios.get(`account/audit-trail/`, {
      requestType: "inbound",
      data: body,
    });
    return data;
  },
  deleteAdmin: async (body) => {
    const { data } = await Axios.delete(`account/admin/${body}/`);
    return data;
  },
};
